import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import "./TopNavbar.css";

const TopNavbar = () => {
  const navigate = useNavigate();

  const { language, setLanguage } = useContext(LanguageContext);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  const handleRegisterClick = () => {
    navigate("/Register");
  };
  const handleLoginClick = () => {
    let getItem = JSON.parse(localStorage.getItem("kkm_auth"));
    if (getItem) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }

  };

const FindLogin = () => {
  const { language } = useContext(LanguageContext); 
  const getItem = JSON.parse(localStorage.getItem("kkm_auth"));

  return getItem
    ? language === "ta" 
      ? "டாஷ்போர்டு" 
      : "Dashboard"
    : language === "ta" 
      ? "உள்நுழைய" 
      : "Login";
};


  return (
    <div className="topbar d-flex justify-content-between align-items-center px-3">
      <div className="language-toggle">
        <span
          onClick={() => handleLanguageChange("ta")}
          className={language === "ta" ? "active" : ""}
        >
          தமிழ்
        </span>
        {" | "}
        <span
          onClick={() => handleLanguageChange("en")}
          className={language === "en" ? "active" : ""}
        >
          English
        </span>
      </div>
      <div className="topbar-layout d-flex align-items-center justify-content-between flex-wrap">
        <div className="help-line">
          <strong>{language === "ta" ? "உதவி மையம்" : "Help Line"}</strong> :
          9952676737
        </div>
        <div className="button-row">
          <button className="login-register-btn" onClick={handleLoginClick}>
            <strong>{language === "ta" ? FindLogin() : FindLogin()}</strong>
          </button>
          <button className="register-btn" onClick={handleRegisterClick}>
            {language === "ta" ? "பதிவு செய்ய" : "Register"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
